import { memo } from "react";
import { ViewTableCell } from "@design-system/ViewTable/ViewTableCell";
import { formatBusinessDate, formatDateOnly } from "@helpers/date";
import { HistoryDetailsBaseRow } from "../../cells/historyDetailsBaseRow";
import styles from "./JournalEntryCells.module.scss";

interface JournalEntryListDateCellProps {
    row: { original: HistoryDetailsBaseRow };
}

export const JournalEntryListDateCell = memo(
    ({ row }: JournalEntryListDateCellProps) => (
        <ViewTableCell className={styles.dateCell}>
            {row.original.dateOnly
                ? formatDateOnly(row.original.dateOnly)
                : formatBusinessDate(new Date(row.original.date))}
        </ViewTableCell>
    ),
);

JournalEntryListDateCell.displayName = "JournalEntryListDateCell";
